import { finder } from './finder';

import { isInvalidElement } from '../invalidElements';

const attributesBlacklist = [
  'id',
  'href',
  'src',
  'class',
  'style',
  'viewBox',
  'xmlns',
  'xmlns:xlink',
  'd',
  'fill',
  'stroke',
];

export function cssSelectorForElement(
  el: HTMLElement | null,
  document?: Document,
): string | undefined {
  if (!el) {
    return undefined;
  }

  try {
    // finder can crash if we encounter no match, this can happen for various reasons including
    // the website changing mid render
    return finder(el, document, { attr: (name) => !attributesBlacklist.includes(name) });
  } catch (e) {
    return undefined;
  }
}

interface ValidSelector {
  valid: true;
}

interface InvalidSelector {
  valid: false;
  reason: string;
}

export const isSelectorValid = (selector?: string): ValidSelector | InvalidSelector => {
  try {
    const matches = document.querySelectorAll(selector ?? '');

    if (matches.length === 0) {
      return { valid: false, reason: 'No matches' };
    }

    if (selector?.includes('nth-child')) {
      return { valid: false, reason: 'nth-child is unsupported' };
    }

    // valid when the element appears in document and is not an invalid tag type
    const validMatches = Array.from(matches).some((el) => {
      return !isInvalidElement(el.tagName);
    });

    if (!validMatches) {
      return { valid: false, reason: 'Selected element is unsupported' };
    }

    return { valid: true };
  } catch (e) {
    return { valid: false, reason: 'The selector you provided has a syntax problem' };
  }
};
